import axios from 'axios';
import {API_URL, SECRET_KEY} from "../config/site.config"

export const request = axios.create({
    baseURL: API_URL,
    timeout: 1000 * 60,
    headers: {
        SecretKey: SECRET_KEY,
        "Content-Type": "application/json"
    }
})